import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Partners from './pages/Partners';
import Layout from './components/Layout';
import Login from './components/Login';
import NotFound from './pages/NotFound';
import {getData} from "./api/api";
import Merchants from "./pages/Merchants";
import StaticQrs from "./pages/StaticQrs";
import BankAccounts from "./pages/BankAccounts";
import Terminals from "./pages/Terminals";
import TransactionQrs from "./pages/TransactionQrs";
import MccCodes from "./pages/MccCodes";

function App() {
    const [authenticated, setAuthenticated] = useState(!!localStorage.getItem('accessToken'));
    const [loading, setLoading] = useState(true);
    const [currentUser, setCurrentUser] = useState(true);

    const checkAuth = async () => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            try {
                const response = await getData("/user/get-current-user");
                if (response?.data?.success){
                    setAuthenticated(true);
                    setCurrentUser(response?.data?.data);
                }else {
                    localStorage.removeItem('accessToken');
                    setAuthenticated(false);
                }

            } catch (error) {
                if (error.response?.status === 403) {
                    localStorage.removeItem('accessToken');
                    setAuthenticated(false);
                } else {
                    console.error('API xatosi:', error);
                }
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        checkAuth();
    }, []);

    if (loading) {
        return <div>Yuklanmoqda...</div>;
    }

    if (!authenticated) {
        return <Login setAuthenticated={setAuthenticated} />;
    }
    return (
        <BrowserRouter>
            <Layout currentUser={currentUser}>
                <Routes>
                    <Route path="/" element={<Partners />} />
                    <Route path="/merchants" element={<Merchants />} />
                    <Route path="/bank-accounts" element={<BankAccounts />} />
                    <Route path="/terminals" element={<Terminals />} />
                    <Route path="/static-qr" element={<StaticQrs />} />
                    <Route path="/transactions-qr" element={<TransactionQrs />} />
                    <Route path="/transactions" element={<TransactionQrs />} />
                    <Route path="/mcc-codes" element={<MccCodes/>} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;